<rx-intuitive-teeth-orchestrator-layout>
	<rx-intuitive-art-teeth-diagram
		rx-intuitive-teeth-diagram-diagram
		[upperJaw]="(upperJaw$ | async) ?? []"
		[lowerJaw]="(lowerJaw$ | async) ?? []"
		[chartReadOnly]="(chartReadOnly$ | async) ?? false"
		(toothClicked)="onToothClicked($event)"
		(resetSelectedRequested)="onResetSelectedRequested()"
	></rx-intuitive-art-teeth-diagram>
	<rx-intuitive-art-treatment-buttons
		rx-intuitive-teeth-diagram-buttons
		[attr.data-bi-attr-selected-tooth-count]="(selectedToothIds$ | async)?.length || '0'"
		[visibleIntegrities]="(availableIntegrityId | async) ?? []"
		[selectedIntegrity]="(selectedIntegrity$ | async) ?? undefined"
		[enabledIntegrities]="(enabledIntegrity | async) ?? []"
		[visibleDefinitions]="(availableDefinitionIds | async) ?? []"
		[selectedDefinitions]="(selectedDefinitions$ | async) ?? []"
		[enabledDefinitions]="(enabledDefinitions$ | async) ?? []"
		[disabled]="(indicationButtonsDisabled$ | async) ?? false"
		[asLabel]="(indicationButtonsAsLabel$ | async) ?? false"
		(integritySelected)="onIntegritySelected($event)"
		(definitionSelected)="onDefinitionSelected($event)"
	></rx-intuitive-art-treatment-buttons>

	<div rx-intuitive-teeth-diagram-panel class="rx-intuitive-art-orchestrator__panel">
		<rx-intuitive-art-treatment-viewlist
			*ngIf="(hasSidePanelContent$ | async)"
			[items]="(treatmentListItems$ | async) ?? []"
			[chartReadOnly]="(chartReadOnly$ | async) ?? false"
			(resetRequested)="onResetRequested($event)"
		/>
		<div class="rx-intuitive-teeth-diagram__no-editor" *ngIf="showSidePanelPlaceholder$ | async">
			<span class="rx-intuitive-teeth-diagram__no-editor-text">
				{{ 'ArtTreatments.ART.SelectTeethToStart' | translate }}
			</span>
		</div>
	</div>

	<rx-intuitive-teeth-diagram-footer
		rx-intuitive-teeth-diagram-footer
		[showBackButton]="(showPanelBack$ | async) ?? false"
		(back)="focusDiagram()"
	/>
</rx-intuitive-teeth-orchestrator-layout>
